// @flow
import Enum from 'common/enums/Enum';

export const ProviderEnum = new Enum({
    ClientRead: 'CLIENT_READ',
    ClientGeocoder: 'CLIENT_GEOCODER',
    LocusGeocoder: 'LOCUS_GEOCODER',
    SystemLearnt: 'SYSTEM_LEARNT'
});

export const ConfidenceEnum = new Enum({
    Low: 'LOW',
    Medium: 'MEDIUM',
    High: 'HIGH'
});
